import { socketEvent, timerChangedMessageSchema } from "@orsane/schema/realtime";
import { useQueryClient } from "@tanstack/react-query";
import { useSocketMessage } from "@/lib/socket/SocketContext";
import { useTRPC } from "@/lib/trpc";

/**
 * The single subscriber for `timer:changed`, mounted once in the app shell.
 *
 * It has to be exactly one: useSocketMessage's cleanup calls `socket.off(event)` without
 * a handler, so a second component listening on the same event would silently
 * unregister this one when it unmounts. Timer panels therefore never subscribe
 * themselves — they re-render off the query cache this invalidates.
 */
export function TimerRealtimeBridge() {
    const trpc = useTRPC();
    const queryClient = useQueryClient();

    useSocketMessage({
        event: socketEvent.timer_changed,
        schema: timerChangedMessageSchema,
        callback: ({ taskId, customAttributeId }) => {
            queryClient.invalidateQueries({
                queryKey: trpc.timer.list.queryKey({ taskId, customAttributeId }),
            });
        },
    });

    return null;
}
